import * as StartPermit from '../schemas/permits/Kmart/startPermit.json'
import * as EndPermit from '../schemas/permits/Kmart/endPermit.json'

export default {
    type: 'Kmart Permit',
    schemas: {
        'Start Permit': StartPermit,
        'Sign-off Permit': EndPermit,
    },
}